"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogHandler = void 0;
var handler_js_1 = require("./handler.js");
Object.defineProperty(exports, "LogHandler", { enumerable: true, get: function () { return handler_js_1.LogHandler; } });
//# sourceMappingURL=index.js.map